import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';

import injectReducer from '../../../utils/injectReducer';
import injectSaga from '../../../utils/injectSaga';
import taggingSaga from '../../Common/Tagging.js/sagas';
import * as taggingActions from '../../Common/Tagging.js/actions';

import progressivePlansReducer from '../@Redux/Reducer/progressivePlans.reducer';

import progressivePlansSaga from '../@Redux/progressivePlans.saga';
import * as cartActions from '../../../services/Cart/actions';
import cartSaga from '../../../services/Cart/sagas';
import addonsSaga from '../../Addons/sagas';
import nbsSaga from '../../../components/NextGen/NBS/@Redux/sagas/index';
import ipiSaga from '../../../components/NextGen/ImportantPlanInfo/@Redux/sagas/index';

import * as addonsActions from '../../Addons/actions';

export const mapStateToProps = (state) => {
  const currentView = state.currentView || {};
  const readDlPlans = state.tagging?.readDlPlans;
  return {
    currentView,
    readDlPlans,
  };
};

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...cartActions, ...taggingActions, ...addonsActions }, dispatch);
}
export const withReducer = compose(
  injectReducer(
    { key: 'progressivePlans', reducer: progressivePlansReducer },
    // { key: 'typeAheadInfo', reducer: typeAheadReducer }
  ),
);

export const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const withSaga = compose(
  injectSaga({ key: 'progressivePlans', saga: progressivePlansSaga }),
  injectSaga({ key: 'taggingDetails', saga: taggingSaga }),
  injectSaga({ key: 'cartDetails', saga: cartSaga }),
  injectSaga({ key: 'addons', saga: addonsSaga }),
  injectSaga({ key: 'nbsSagas', saga: nbsSaga }),
  injectSaga({ key: 'ipiSagas', saga: ipiSaga }),
);
